module.exports = "/_next/static/images/UseAi-b5a5ed0bf828b737ee752da1deaaf9bd.png";